import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-t border-slate-800 bg-slate-900 py-8 text-slate-400" }
const _hoisted_2 = { class: "container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-6 text-sm" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "hover:text-white transition-colors"
  }, "Privacy Policy"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "hover:text-white transition-colors"
  }, "Terms of Use")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, " © " + _toDisplayString(new Date().getFullYear()) + " CodeCopy. All rights reserved. ", 1),
      _hoisted_4
    ])
  ]))
}